module.exports = __webpack_public_path__ + "media/videoblue.da24d109.mp4";